module.exports = __webpack_public_path__ + "static/media/CompanyImage1.5a87cd6b.jpg";